import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import InfoIcon from 'components/icons/IconInfoNew';
import BrandTooltip from 'components/consumer/BrandTooltip';
import PDPFinancing from 'components/consumer/PDP/PDPFinancing';
import usePDPPrice from 'data-hooks/usePDPPrice';
import PDPPriceSection from '../PDPPriceSection';
import PDPPriceSectionUI from '../PDPPriceSection/PDPPriceSectionUI';
import PDPPriceAndFinancePlaceholder from './PDPPriceAndFinancePlaceholder';
const PDPPriceAndFinance = t0 => {
  const $ = _c(24);
  const {
    loading,
    isEditOrder,
    pdpIsModularBYOProduct
  } = t0;
  const {
    state
  } = useLocation() ?? {};
  let t1;
  if ($[0] !== state) {
    t1 = state ?? {};
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const locationState = t1;
  const {
    price: priceFromRouterState,
    originalPrice: originalPriceFromRouterState
  } = locationState;
  const {
    data: priceData
  } = usePDPPrice() ?? {};
  if (loading && priceFromRouterState) {
    const hasDiscountFromRouterState = originalPriceFromRouterState && originalPriceFromRouterState > priceFromRouterState;
    const t2 = originalPriceFromRouterState ?? priceFromRouterState;
    let t3;
    if ($[2] !== hasDiscountFromRouterState || $[3] !== priceFromRouterState || $[4] !== t2) {
      t3 = <PDPPriceSectionUI price={t2} salePrice={priceFromRouterState} hasDiscount={hasDiscountFromRouterState} hasTieredDiscount={false} />;
      $[2] = hasDiscountFromRouterState;
      $[3] = priceFromRouterState;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== loading) {
      t4 = <PDPFinancing loading={loading} />;
      $[6] = loading;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== priceData?.clearanceStockPerSKU?.flashSale || $[9] !== priceData?.isClearance) {
      t5 = !priceData?.clearanceStockPerSKU?.flashSale && priceData?.isClearance && <BrandTooltip openOnHover={true} className="ml-0 w-fit" iconSize="big" closeButtonClassName="lg:hidden" customIcon={<div className="text-sm text-red font-bold mt-1 flex justify-center items-center"><span>Final Sale</span><InfoIcon color="green" height={13} width={13} aria-hidden="true" /></div>}>{"Clearance item: ineligible for returns except for items arriving damaged & documented by carrier. Ineligible for warranty claims unless reports of defects are submitted within 14 days of delivery, cosmetic damage isn't covered."}</BrandTooltip>;
      $[8] = priceData?.clearanceStockPerSKU?.flashSale;
      $[9] = priceData?.isClearance;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
      t6 = <div className="flex-1">{t3}{t4}{t5}</div>;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t2;
  if ($[15] !== isEditOrder || $[16] !== loading || $[17] !== pdpIsModularBYOProduct) {
    t2 = loading ? <PDPPriceAndFinancePlaceholder /> : !isEditOrder && <PDPPriceSection pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[15] = isEditOrder;
    $[16] = loading;
    $[17] = pdpIsModularBYOProduct;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== loading) {
    t3 = <PDPFinancing loading={loading} />;
    $[19] = loading;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t2 || $[22] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
PDPPriceAndFinance.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool
};
export default PDPPriceAndFinance;